export const visit = (vm, at) => {
vm(require("quotes-ui-lib/lang/en.lyaml"));
vm(require("growth-payments-core/lang/en.lyaml"));
at({ "en": { "quotesHighlightCard": { "propertyLabels": { "amount": "Amount:", "number": "Quote number:", "status": "Status:", "totalContractValue": "Total contract value:", "quoteAmount": "Quote amount:" }, "propertyValues": { "number": "#{{ number }}" } } } });
};